import React from "react";
import "./FooterMobile.css";
import * as _ from "lodash";
import { ReactComponent as NexiLogo } from "../../../resources/images/logoNexi.svg";
import { GoogleTagManagerService } from "../../../services/analitycs/GoogleTagManagerService";
import { Route } from "react-router-dom";

export class FooterMobile extends React.Component<any, any> {
  private static T_AND_C_KEY = "terms_and_condition";

  manageTermsAndConditions(history: any) {
    GoogleTagManagerService.getInstance().pushInteractionEvent("Click", "footer", "click", "termini e condizioni");
    console.log("[Footer][goToTermsAndConditions] go to T&C page!");
    history.push("/termsAndConditions", { fromHome: true });
  }

  render() {
    return (
      <div id={"mobile-footer-body"}>
        <div className={"mobile-footer-content"}>
          <NexiLogo className={"logo-image"} />
          <div className={"mobile-support-link"}>
            <a href={this.props.supportLink}>SUPPORTO</a>
          </div>
          <div className={"mobile-separator"} />
          <div className={"mobile-menu-contents"}>
            <a href={this.props.mainLink} className={"main-link"}>
              NEXI.IT
            </a>
            {_.map(this.props.menuItems, (value: object) => {
              // @ts-ignore
              let ref: string = value["ref"] as string;
              // @ts-ignore
              let label: string = value["label"];
              // @ts-ignore
              let key: string = value["key"];
              return (
                <div key={key} className={"mobile-menu-links"}>
                  {FooterMobile.T_AND_C_KEY === key ? (
                    <Route
                      render={({ history }) => {
                        return (
                          <p
                            className={"mobile-paragraph-link-anchor-custom"}
                            key={key}
                            onClick={() => {
                              this.manageTermsAndConditions(history);
                              return false;
                            }}>
                            {label}
                          </p>
                        );
                      }}
                    />
                  ) : (
                    <a className={"menu-link-anchor"} key={key} href={ref}>
                      {label}
                    </a>
                  )}
                </div>
              );
            })}
            <p className={"mobile-copyright-text"}>Copyright &copy; 2020 Tutti i diritti riservati.</p>
          </div>
        </div>
      </div>
    );
  }
}
